import React, { useState, useEffect, useRef, Suspense } from 'react'
import { createPortal } from 'react-dom'
import axios from 'axios'
import { showLoading } from 'react-global-loading';
import { API_URL } from '../../Constant';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../assets/Messages.json'
import { Link, useNavigate } from 'react-router-dom';
import { generateYearRange, isNumeric, validateButtonASIBlock, getStatusFlagValue, isAsiStatusSixEditAllowedForRole, isHqAsiAdminRole, setAsiPrintPreviewActive } from '../../Custom/Custom';
import asiTitle from '../../asi.json';

const BlockA = React.lazy(() => import('./BlockA'));
const BlockB = React.lazy(() => import('./BlockB'));
const BlockC = React.lazy(() => import('./BlockC'));
const BlockD = React.lazy(() => import('./BlockD'));
const BlockE = React.lazy(() => import('./BlockE'));
const BlockF = React.lazy(() => import('./BlockF'));
const BlockG = React.lazy(() => import('./BlockG'));
const BlockH = React.lazy(() => import('./BlockH'));
const BlockI = React.lazy(() => import('./BlockI'));
const BlockJ = React.lazy(() => import('./BlockJ'));
const BlockK = React.lazy(() => import('./BlockK'));
const BlockL = React.lazy(() => import('./BlockL'));
const BlockM = React.lazy(() => import('./BlockM'));
const ASIComparision = React.lazy(() => import('./ASIComparision'));

export default function BlockN({
   blockPageInfo,
   config,
   userInfoObject,
   blockInfo,
   accessAsiBlock,
   decode_token
}) {

   const [commentsOfSuperintendingOfficer, setCommentsOfSuperintendingOfficer] = useState('');
   const [superintendingNameError, setSuperintendingNameError] = useState('');
   const statusUnitCode = localStorage.getItem('statusUnitCode')
   const [statusFlageval, setstatusFlageval] = useState('');
   const navigate = useNavigate();
   const yearRange = generateYearRange(blockInfo.surveyYear);
   const [buttonStatus, setButtonStatus] = useState('');
   const isStatusFlagOne = String(statusFlageval ?? '').trim() === '1';
   const roleCodes = decode_token?.id?.ROLE_CODE
      ? String(decode_token.id.ROLE_CODE)
           .split('|')
           .map((r) => String(r).trim())
           .filter(Boolean)
      : [];
   const isDivasiRole = roleCodes.includes('DIVASI');
   const isHqRole = roleCodes.includes('HQADM') || roleCodes.includes('HQASI');
   const isHqAsiAdmin = isHqAsiAdminRole(roleCodes);
   const isHqStatusFlagThree = isHqRole && String(statusFlageval ?? '').trim() === '3';
   const isRestrictedRoleWithEmptyStatusFlag = (isDivasiRole || isHqRole) && String(statusFlageval ?? '').trim() === '';
   // BlockL data states
   const [blockLItemData, setBlockLItemData] = useState({});
   const [blockLGVANVACalculation, setBlockLGVANVACalculation] = useState({
      gva: '',
      nva: '',
      totalInput: '',
      totalOutput: '',
      rejectedReason: '',
      ratioOutputInput: '',
      balanceSheet: '',
      profitAndLossStatement: '',
      attendanceMusterRoll: '',
      inspectionReport: '',
      others: ''
   });
   const [balanceSheet, setBalanceSheet] = useState('');
   const [profitAndLossStatement, setProfitAndLossStatement] = useState('');
   const [attendanceMusterRoll, setAttendanceMusterRoll] = useState('');
   const [inspectionReport, setInspectionReport] = useState('');
   const [others, setOthers] = useState('');
   // BlockM data states
   const [blockMData, setBlockMData] = useState({});
   const [showPrintModal, setShowPrintModal] = useState(false);
   const [showComparisonModal, setShowComparisonModal] = useState(false);
   const [previewProgress, setPreviewProgress] = useState(0);
   const [isPrintPreparing, setIsPrintPreparing] = useState(false);

   const BlockNPreview = ({ commentsOfSuperintendingOfficer, rejectedReason, blockInfo }) => (
      <div className="print-blockn-preview">
         <div className="table-responsive asi_block_table">
            <table className="table table-bordered">
               <thead>
                  <tr>
                     <th colSpan="2">Block N</th>
                  </tr>
               </thead>
               <tbody>
                  <tr>
                     <td style={{ width: '30%' }}>DSL No</td>
                     <td>{blockInfo.dslNo || '-'}</td>
                  </tr>
                  <tr>
                     <td>Survey Year</td>
                     <td>{blockInfo.surveyYear || '-'}</td>
                  </tr>
                  <tr>
                     <td>Comments of Data Entry Officer/Scrutinising Officer</td>
                     <td>{commentsOfSuperintendingOfficer || '-'}</td>
                  </tr>
                  <tr>
                     <td>Rejected Reason</td>
                     <td>{rejectedReason || '-'}</td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>
   );

   const printSections = [
      { 
         key: 'A', 
         label: 'Block A', 
         Component: BlockA,
         props: { blockPageInfo, config, userInfoObject, blockInfo, accessAsiBlock, decode_token, previewMode: true }
      },
      { 
         key: 'B', 
         label: 'Block B', 
         Component: BlockB,
         props: { blockPageInfo, config, userInfoObject, blockInfo, accessAsiBlock, decode_token, previewMode: true }
      },
      { 
         key: 'C', 
         label: 'Block C', 
         Component: BlockC,
         props: { blockPageInfo, config, userInfoObject, blockInfo, accessAsiBlock, decode_token, previewMode: true }
      },
      { 
         key: 'D', 
         label: 'Block D', 
         Component: BlockD,
         props: { blockPageInfo, config, userInfoObject, blockInfo, accessAsiBlock, decode_token, previewMode: true }
      },
      { 
         key: 'E', 
         label: 'Block E', 
         Component: BlockE,
         props: { blockPageInfo, config, userInfoObject, blockInfo, accessAsiBlock, decode_token, previewMode: true }
      },
      { 
         key: 'F', 
         label: 'Block F', 
         Component: BlockF,
         props: { blockPageInfo, config, userInfoObject, blockInfo, accessAsiBlock, decode_token, previewMode: true }
      },
      { 
         key: 'G', 
         label: 'Block G', 
         Component: BlockG,
         props: { blockPageInfo, config, userInfoObject, blockInfo, accessAsiBlock, decode_token, previewMode: true }
      },
      { 
         key: 'H', 
         label: 'Block H', 
         Component: BlockH,
         props: { blockPageInfo, config, userInfoObject, blockInfo, accessAsiBlock, decode_token, previewMode: true }
      },
      { 
         key: 'I', 
         label: 'Block I', 
         Component: BlockI,
         props: { blockPageInfo, config, userInfoObject, blockInfo, accessAsiBlock, decode_token, previewMode: true }
      },
      { 
         key: 'J', 
         label: 'Block J', 
         Component: BlockJ,
         props: { blockPageInfo, config, userInfoObject, blockInfo, accessAsiBlock, decode_token, previewMode: true }
      },
      { 
         key: 'K', 
         label: 'Block K', 
         Component: BlockK,
         props: { blockPageInfo, config, userInfoObject, blockInfo, accessAsiBlock, decode_token, previewMode: true }
      },
      { 
         key: 'L', 
         label: 'Block L', 
         Component: BlockL,
         props: { blockPageInfo, config, userInfoObject, blockInfo, accessAsiBlock, decode_token, previewMode: true }
      },
      { 
         key: 'M', 
         label: 'Block M', 
         Component: BlockM,
         props: { blockPageInfo, config, userInfoObject, blockInfo, accessAsiBlock, decode_token, previewMode: true }
      },
      {
         key: 'N',
         label: 'Block N',
         Component: BlockNPreview,
         props: {
            commentsOfSuperintendingOfficer,
            rejectedReason: blockLGVANVACalculation.rejectedReason,
            blockInfo
         }
      }
   ];

   const STATUS2_PRINT_BLOCKS = ['A', 'B', 'C', 'E', 'L', 'M', 'N'];
   const STATUS3_PRINT_BLOCKS = ['A', 'B', 'C', 'L', 'M', 'N'];
   const LIMITED_PRINT_BLOCKS = ['A', 'B', 'L', 'M', 'N'];

   const getActivePrintBlockKeys = () => {
      if (statusUnitCode === '2') return STATUS2_PRINT_BLOCKS;
      if (statusUnitCode === '3') return STATUS3_PRINT_BLOCKS;
      if (['4', '5', '7', '8'].includes(statusUnitCode)) return LIMITED_PRINT_BLOCKS;
      return null;
   };

   const activePrintBlockKeys = getActivePrintBlockKeys();
   const activePrintSections = activePrintBlockKeys
      ? printSections.filter(({ key }) => activePrintBlockKeys.includes(key))
      : printSections;
   const printBlocksLabel = activePrintBlockKeys
      ? activePrintBlockKeys.join(', ')
      : 'A to N';
   const printPreviewTitle = activePrintBlockKeys
      ? `Print Preview: Block ${printBlocksLabel}`
      : 'Print Preview: Block A to N';
   const printAllButtonLabel = activePrintBlockKeys
      ? `Print Blocks ${printBlocksLabel}`
      : 'Print all Blocks A-N';

   const shouldSkipValidation = ['4', '5', '7', '8'].includes(statusUnitCode);

   // Rejected Reason Log states
   const [rejectLog, setRejectLog] = useState([]);
   const [showRejectLogModal, setShowRejectLogModal] = useState(false);
   const [rejectLogError, setRejectLogError] = useState('');
   const [isRejectLogFetching, setIsRejectLogFetching] = useState(false);
   const bodyOverflowRef = useRef('');
   let srNo = 0;


   useEffect(() => {
      blockNAllData();
      fetchBlockLData();
      fetchBlockMData();
   }, [])

   // Function to fetch BlockL data
   const fetchBlockLData = async () => {
      const newObject = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
      };
      try {
         const response = await axios.post(`${API_URL}api/asi/blockLForm`, newObject, config);
         const { data, status } = response.data;
         if (status) {
            const responseBlockLData = data.blockKData;
            const initialData = {};
            responseBlockLData.forEach(item => {
               initialData[item.ecIndicatorCode] = {
                  dslNo: item.dslNo,
                  surveyYear: item.surveyYear,
                  ecIndicatorCode: item.ecIndicatorCode,
                  code: item.code,
                  gva: item.gva,
                  nva: item.nva
               };
            });
            setBlockLItemData(initialData);
            
            // Extract file names from API response paths
            const extractFileName = (filePath) => {
               if (!filePath || filePath === '') return '';
               const fileName = filePath.split('/').pop() || filePath.split('\\').pop();
               return fileName ? `${API_URL}uploads/${fileName}` : '';
            };
            
            const updatedGVANVACalculation = {
               ...data.GVANVACalculation,
               balanceSheet: extractFileName(data.GVANVACalculation.balanceSheet || ''),
               profitAndLossStatement: extractFileName(data.GVANVACalculation.profitAndLossStatement || ''),
               attendanceMusterRoll: extractFileName(data.GVANVACalculation.attendanceMusterRoll || ''),
               inspectionReport: extractFileName(data.GVANVACalculation.inspectionReport || ''),
               others: extractFileName(data.GVANVACalculation.others || '')
            };
            setBlockLGVANVACalculation(updatedGVANVACalculation);
         }
      } catch (error) {
         console.error('Error fetching BlockL data:', error);
      }
   };

   // Function to fetch BlockM data
   const fetchBlockMData = async () => {
      const newObject = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
      };
      try {
         const response = await axios.post(`${API_URL}api/asi/blockMForm`, newObject, config);
         const { data, status } = response.data;
         if (status && data.asiBlockMdata && data.asiBlockMdata.length > 0) {
            setBlockMData(data.asiBlockMdata[0]);
         }
      } catch (error) {
         console.error('Error fetching BlockM data:', error);
      }
   };

   // Function to handle page load Form data
   const blockNAllData = async () => {
      const newObject = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
      };
      try {
         showLoading(true);
         const response = await axios.post(`${API_URL}api/asi/blockNForm`, newObject, config);
         const { data, status } = response.data;
         const responseBlockNData = data.asiBlockNResults[0];
         if (status && responseBlockNData) {
            setCommentsOfSuperintendingOfficer(responseBlockNData.comments_of_superintending_officer)
            setstatusFlageval(responseBlockNData.status_flag);
            const IsButtonStatus = await validateButtonASIBlock(decode_token, responseBlockNData.status_flag);
            setButtonStatus(IsButtonStatus)
         }
      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
         showLoading(false);
      }

   }



   // Function to handle reset Form Data
   const handleReset = () => {
      setCommentsOfSuperintendingOfficer('')
   }

   const handleInputSuperintendingOfficer = (userName) => {
      // Industry standard validation: allow text with max 500 characters
      if (userName.length >= 0 && userName.length <= 500) {
         setSuperintendingNameError("");
         return true;
      } else {
         setSuperintendingNameError("Maximum 500 characters allowed.");
         return false;
      }
   };



   const hnadleTextBoxOnChange = (e) => {
      const { name, value } = e.target;

      switch (name) {
         case 'comments_of_superintending_officer':
            // Industry standard: max 500 characters (maxLength attribute handles the limit)
            setCommentsOfSuperintendingOfficer(value);
            // Validate and show error if needed
            handleInputSuperintendingOfficer(value);
            break;
      }
   }


   // Function to handle going to the previous block
   const handlePrevious = () => {
      const confirmed = window.confirm("Have you saved your changes?");
      if (confirmed) {
         navigate("/BlockM")
      }
   }

   const openPrintAllBlocksModal = () => {
      setAsiPrintPreviewActive(true);
      showLoading(true);
      setShowPrintModal(true);
      setPreviewProgress(activePrintSections.length);
      setIsPrintPreparing(true);
      bodyOverflowRef.current = document.body.style.overflow || '';
      document.body.style.overflow = 'hidden';
   };

   const closePrintAllBlocksModal = () => {
      setShowPrintModal(false);
      setPreviewProgress(0);
      setIsPrintPreparing(false);
      setAsiPrintPreviewActive(false);
      showLoading(false);
      document.body.style.overflow = bodyOverflowRef.current || '';
   };

   useEffect(() => {
      if (!showPrintModal) return;

      const timer = window.setTimeout(() => {
         setIsPrintPreparing(false);
         showLoading(false);
      }, 4500);

      return () => window.clearTimeout(timer);
   }, [showPrintModal]);

   const handleConfirmPrintAll = () => {
      window.print();
   };

   useEffect(() => {
      if (!showPrintModal) return;
      const afterPrint = () => {
         closePrintAllBlocksModal();
      };
      window.addEventListener('afterprint', afterPrint);
      return () => {
         window.removeEventListener('afterprint', afterPrint);
         setAsiPrintPreviewActive(false);
         showLoading(false);
         document.body.style.overflow = bodyOverflowRef.current || '';
      };
   }, [showPrintModal]);

   const handleModalOverlayClick = (e) => {
      if (e.target === e.currentTarget) {
         closePrintAllBlocksModal();
      }
   };


   //All block validation Data
   const blockValidation = async () => {

      let postData = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
      }

      try {
         showLoading(true);
         const response = await axios.post(`${API_URL}api/asi/blockValidation`, postData, config);
         const { data, status } = response.data;
         const accessIds = data.allblockData
         if (accessIds.length > 0) {
            if (accessIds.length > [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].length) {
               accessAsiBlock(accessIds)
            } else {
               accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15])
            }
         } else {
            accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15])
         }
         showLoading(false);
         return true;

      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {

      }

   }






   // Function to save BlockL data
   const saveBlockLData = async (buttonType) => {
      if(buttonType === 'REJECT'){
         if(blockLGVANVACalculation.rejectedReason.length === 0){
            toast.error(`Please fill reason for rejection`, messages.COLOR_RED);
            return false;
         } else if (blockLGVANVACalculation.rejectedReason.length > 500){
            toast.error(`Character limit exceeded`, messages.COLOR_RED);
            return false;
         }
      }

      const shouldSkipValidation = ['4', '5', '7','8'].includes(statusUnitCode) && blockInfo.surveyYear == '2024';
      if(shouldSkipValidation && (inspectionReport === '' && blockLGVANVACalculation.inspectionReport == '')){
         toast.error(`Please Upload Inspection Report`, messages.COLOR_RED);
         return false;
      }

      let customItemCodes = [];
      const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);

      for (let ecIndicatorCode in blockLItemData) {
         const customObject = {
            dslNo: blockLItemData[ecIndicatorCode].dslNo,
            surveyYear: blockLItemData[ecIndicatorCode].surveyYear,
            code: blockLItemData[ecIndicatorCode].code,
            ecIndicatorCode: blockLItemData[ecIndicatorCode].ecIndicatorCode,
            gva: blockLGVANVACalculation.gva,
            nva: blockLGVANVACalculation.nva,
            totalInput: blockLGVANVACalculation.totalInput,
            totalOutput: blockLGVANVACalculation.totalOutput,
            rejectedReason: blockLGVANVACalculation.rejectedReason,
            ratioOutputInput: blockLGVANVACalculation.ratioOutputInput,
            statusFlag: clickButtonStatusFlag,
         };
         customItemCodes.push(customObject);
      }

      const newObject = {
         itemCodes: customItemCodes,
         payload: {
            dsl_no: blockInfo.dslNo,
            survey_year: blockInfo.surveyYear,
            buttonType: buttonType,
            statusFlag: clickButtonStatusFlag
         }
      }

      const formData = new FormData();
      const newObjectString = JSON.stringify(newObject);
      formData.append('BlockLData', newObjectString);
      formData.append('balanceSheet', balanceSheet);
      formData.append('profitAndLossStatement', profitAndLossStatement);
      formData.append('attendanceMusterRoll', attendanceMusterRoll);
      formData.append('inspectionReport', inspectionReport);
      formData.append('others', others);

      try {
         const response = await axios.post(`${API_URL}api/asi/blockLFormSaveToDB`, formData, config);
         const { status, message } = response.data;
         if (status) {
            return true;
         }
      } catch (error) {
         console.error(error);
         toast.error('Error saving BlockL data.', messages.COLOR_RED);
         return false;
      }
      return false;
   };

   // Function to save BlockM data
   const saveBlockMData = async (buttonType) => {
      const shouldSkipValidation = ['4', '5', '7','8'].includes(statusUnitCode) && blockInfo.surveyYear == '2024';
      if(!shouldSkipValidation){
         // BlockM validation - check if required fields are present
         if (!blockMData || !blockMData.name_of_superintending_officer || !blockMData.name_and_designation_of_scrutinising_officer) {
            // If BlockM data is not complete, skip saving BlockM
            return true;
         }
      }

      // If BlockM data is not available, skip saving
      if (!blockMData || Object.keys(blockMData).length === 0) {
         return true;
      }

      const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);
      const formatDate = (date) => {
         if (!date || date === '0000-00-00') return '';
         try {
            const d = new Date(date);
            if (isNaN(d.getTime())) return '';
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
         } catch (error) {
            return '';
         }
      };

      // BlockM.jsx jaisa exact payload shape bhejo
      const payload = {
         dslNo: blockInfo.dslNo ?? '',
         surveyYear: blockInfo.surveyYear ?? '',
         name_dataEntry_officer:
            blockMData.name_dataEntry_officer ??
            blockMData.name_of_superintending_officer ??
            blockMData.nameOfSuperintendingOfficer ??
            '',
         designation_dataEntry_officer:
            blockMData.designation_dataEntry_officer ??
            blockMData.designation_of_data_entry_officer ??
            blockMData.designationOfDataEntryOfficer ??
            '',
         date_of_receipt_factory: formatDate(blockMData.date_of_receipt_factory ?? blockMData.date_of_receipt_from_factory),
         date_of_verification_compilation: formatDate(blockMData.date_of_verification_compilation),
         date_of_verification: formatDate(blockMData.date_of_verification ?? blockMData.date_of_verification_compilation),
         name_scrutinising_officer:
            blockMData.name_scrutinising_officer ??
            blockMData.name_and_designation_of_scrutinising_officer ??
            blockMData.nameAndDesignationOfScrutinisingOfficer ??
            '',
         designation_scrutinising_officer:
            blockMData.designation_scrutinising_officer ??
            blockMData.designation_of_scrutinising_officer ??
            blockMData.designationOfScrutinisingOfficer ??
            '',
         dates_of_scrutiny: formatDate(blockMData.dates_of_scrutiny),
         date_of_despatch: formatDate(blockMData.date_of_despatch),
         statusFlag: clickButtonStatusFlag ?? ''
      };

      const apiConfig = {
         ...config,
         headers: {
            ...config.headers,
            'Content-Type': 'application/json'
         }
      };

      try {
         const response = await axios.post(`${API_URL}api/asi/blockMFormSaveToDB`, payload, apiConfig);
         const { status, message } = response.data;
         if (status) {
            return true;
         }
      } catch (error) {
         console.error('Error saving BlockM data:', error);
         // Don't show error if BlockM data is not available - just return true to continue
         return true;
      }
      return false;
   };

   // Function to handle update and save form data
   const handleSaveData = async (buttonType) => {
      const shouldSkipValidation = ['4', '5', '7','8'].includes(statusUnitCode) && blockInfo.surveyYear == '2024';
      if(!shouldSkipValidation){
         if (commentsOfSuperintendingOfficer === '') {
            toast.error('Please enter the Comments of Superintending Officer', messages.COLOR_RED);
            return false;
         }
      }

      showLoading(true);
      try {
         // Save BlockL data first
         const blockLSaveResult = await saveBlockLData(buttonType);
         if (!blockLSaveResult) {
            showLoading(false);
            return false;
         }

         // Fetch BlockL data immediately after save to update button status
         await fetchBlockLData();

         // Save BlockM data
         await saveBlockMData(buttonType);

         // Save BlockN data
         const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);
         const newObject = {
            itemCodes: [{
               dslNo: blockInfo.dslNo,
               surveyYear: blockInfo.surveyYear,
               comments_of_superintending_officer: commentsOfSuperintendingOfficer,
               statusFlag: clickButtonStatusFlag
            }],
            payload: {
               dsl_no: blockInfo.dslNo,
               survey_year: blockInfo.surveyYear,
               buttonType: buttonType,
            }
         }

         const response = await axios.post(`${API_URL}api/asi/blockNFormSaveToDB`, newObject, config);
         const { status, message } = response.data;
         if (status) {
            // Fetch BlockL data to update button status
            await fetchBlockLData();
            
            // Fetch BlockN data to update button status
            const blockNFormResponse = await axios.post(`${API_URL}api/asi/blockNForm`, {
               dsl_no: blockInfo.dslNo,
               survey_year: blockInfo.surveyYear
            }, config);
            if (blockNFormResponse.data.status && blockNFormResponse.data.data.asiBlockNResults && blockNFormResponse.data.data.asiBlockNResults.length > 0) {
               const responseBlockNData = blockNFormResponse.data.data.asiBlockNResults[0];
               setstatusFlageval(responseBlockNData.status_flag);
               const IsButtonStatus = await validateButtonASIBlock(decode_token, responseBlockNData.status_flag);
               setButtonStatus(IsButtonStatus);
            }
            
            blockValidation()
            toast.success(message, messages.COLOR_RED);
            return true;
         }
      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
         showLoading(false);
      }

      return false;
   }



   const formatDateTime = (value) => {
      if (!value) return '-';
      try {
         return new Date(value).toLocaleString();
      } catch (error) {
         return value;
      }
   };

   const handleRejectedReasonLog = async () => {
      setRejectLog([]);
      setRejectLogError('');
      setIsRejectLogFetching(true);
      showLoading(true);
      try {
         const payload = {
            dsl_no: blockInfo.dslNo,
            survey_year: blockInfo.surveyYear
         };
         const response = await axios.post(`${API_URL}api/asi/blockL/rejectLog`, payload, config);
         const { status, data, message } = response.data || {};
         if (status && Array.isArray(data) && data.length > 0) {
            const mappedData = data.map((entry, index) => ({
               id: `${entry.dateTime || index}-${index}`,
               level: entry.level || '-',
               reason: entry.reason || '-',
               action: entry.action || '-',
               dateTime: formatDateTime(entry.dateTime)
            }));
            setRejectLog(mappedData);
         } else {
            setRejectLog([]);
            setRejectLogError(message || 'No rejected reason log found.');
         }
      } catch (error) {
         console.error('Error fetching rejected reason log:', error);
         const apiMessage = error.response?.data?.message || error.message || 'Unable to fetch rejected reason log.';
         setRejectLogError(apiMessage);
      } finally {
         setIsRejectLogFetching(false);
         setShowRejectLogModal(true);
         showLoading(false);
      }
   }

   const closeRejectedReasonModal = () => {
      setShowRejectLogModal(false);
   }

   useEffect(() => {
      const anyModalOpen = showRejectLogModal || showComparisonModal;
      if (anyModalOpen) {
         bodyOverflowRef.current = document.body.style.overflow;
         document.body.style.overflow = 'hidden';
      } else if (bodyOverflowRef.current !== undefined) {
         document.body.style.overflow = bodyOverflowRef.current || '';
      }
      return () => {
         document.body.style.overflow = bodyOverflowRef.current || '';
      };
   }, [showRejectLogModal, showComparisonModal]);

   const modalOverlayStyle = {
      display: 'block',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1050,
      pointerEvents: 'auto',
      willChange: 'auto',
      transition: 'none'
   };

   const modalDialogStyle = {
      position: 'relative',
      width: 'auto',
      margin: '1.75rem auto',
      pointerEvents: 'none',
      zIndex: 1051,
      willChange: 'auto',
      transform: 'none',
      transition: 'none'
   };

   const modalContentStyle = {
      maxHeight: '70vh',
      overflowY: 'auto',
      position: 'relative',
      pointerEvents: 'auto',
      border: '1px solid rgba(0, 0, 0, 0.2)',
      borderRadius: '0.5rem',
      boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
      backgroundColor: '#fff',
      willChange: 'auto',
      transform: 'none',
      transition: 'none'
   };

   const comparisonModalOverlayStyle = {
      position: 'fixed',
      inset: 0,
      width: '100vw',
      height: '100vh',
      minWidth: '100%',
      minHeight: '100%',
      zIndex: 10000,
      backgroundColor: 'rgba(0, 0, 0, 0.72)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px 28px',
      overflow: 'hidden',
      pointerEvents: 'auto',
      boxSizing: 'border-box',
   };

   const comparisonModalDialogStyle = {
      width: '100%',
      maxWidth: '1180px',
      height: '90vh',
      maxHeight: '90vh',
      margin: 0,
      pointerEvents: 'auto',
      display: 'flex',
      flexDirection: 'column',
   };

   const comparisonModalContentStyle = {
      height: '100%',
      maxHeight: '90vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      border: '1px solid rgba(0, 0, 0, 0.2)',
      borderRadius: '0.5rem',
      boxShadow: '0 0.75rem 2rem rgba(0, 0, 0, 0.35)',
      backgroundColor: '#fff',
   };

   const comparisonModalBodyStyle = {
      overflowX: 'hidden',
      overflowY: 'auto',
      minHeight: 0,
   };

   const storedLanguage = localStorage.getItem('language');


   // Use useEffect to set button disabled states after DOM is rendered
   useEffect(() => {
      const userLevel = decode_token.id.USER_TYPE;
      const roleCodeRaw = decode_token.id.ROLE_CODE;
      const roles =
         typeof roleCodeRaw === 'string'
            ? roleCodeRaw.split('|').map((r) => String(r).trim()).filter(Boolean)
            : [];
      const isDivasi = roles.includes('DIVASI');
      const sfTrim = String(statusFlageval ?? '').trim();
      let duser = 0;

      // Empty statusFlag ("") => restricted roles keep Save/Submit disabled
      if (sfTrim === '') {
         const isRestrictedRole = roles.includes('DIVASI') || roles.includes('HQADM') || roles.includes('HQASI');
         const saveBtn = document.getElementById("save");
         if (saveBtn) saveBtn.disabled = isRestrictedRole;

         const submitBtn = document.getElementById("submit");
         if (submitBtn) submitBtn.disabled = isRestrictedRole;

         const acceptBtn = document.getElementById("accept");
         if (acceptBtn) acceptBtn.disabled = false;

         const rejectBtn = document.getElementById("reject");
         if (rejectBtn) rejectBtn.disabled = false;

         return;
      }

      // FACTORY LEVEL: "9" par sirf Save on; "5" par FACTO ko bhi Save on (validateButtonASIBlock ke saath)
      if (userLevel === 'FACTORY LEVEL') {
         const saveBtn = document.getElementById("save");
         const submitBtn = document.getElementById("submit");
         const acceptBtn = document.getElementById("accept");
         const rejectBtn = document.getElementById("reject");
         if (sfTrim === '9') {
            if (saveBtn) saveBtn.disabled = false;
            if (submitBtn) submitBtn.disabled = true;
            if (acceptBtn) acceptBtn.disabled = true;
            if (rejectBtn) rejectBtn.disabled = true;
            return;
         }
         if (sfTrim === '5' && roles.includes('FACTO')) {
            if (saveBtn) saveBtn.disabled = false;
            if (submitBtn) submitBtn.disabled = true;
            if (acceptBtn) acceptBtn.disabled = true;
            if (rejectBtn) rejectBtn.disabled = true;
            return;
         }
         if (saveBtn) saveBtn.disabled = true;
         if (submitBtn) submitBtn.disabled = true;
         if (acceptBtn) acceptBtn.disabled = true;
         if (rejectBtn) rejectBtn.disabled = true;
         return;
      }

      // 0 = District Save → sirf DISTRICT: Save/Submit/Reject on; Division/HQ/Factory yahan tak nahi aate (factory upar)
      if (sfTrim === '0') {
         const saveBtn = document.getElementById("save");
         const submitBtn = document.getElementById("submit");
         const acceptBtn = document.getElementById("accept");
         const rejectBtn = document.getElementById("reject");
         if (userLevel === 'DISTRICT LEVEL') {
            if (saveBtn) saveBtn.disabled = false;
            if (submitBtn) submitBtn.disabled = false;
            if (acceptBtn) acceptBtn.disabled = true;
            if (rejectBtn) rejectBtn.disabled = false;
            return;
         }
         if (saveBtn) saveBtn.disabled = true;
         if (submitBtn) submitBtn.disabled = true;
         if (acceptBtn) acceptBtn.disabled = true;
         if (rejectBtn) rejectBtn.disabled = true;
         return;
      }

      // 5 = Factory Save complete → sirf DISTRICT: Save + Submit on; Division/HQ sab band
      if (sfTrim === '5') {
         const saveBtn = document.getElementById("save");
         const submitBtn = document.getElementById("submit");
         const acceptBtn = document.getElementById("accept");
         const rejectBtn = document.getElementById("reject");
         if (userLevel === 'DISTRICT LEVEL') {
            if (saveBtn) saveBtn.disabled = false;
            if (submitBtn) submitBtn.disabled = false;
            if (acceptBtn) acceptBtn.disabled = true;
            if (rejectBtn) rejectBtn.disabled = false;
            return;
         }
         if (saveBtn) saveBtn.disabled = true;
         if (submitBtn) submitBtn.disabled = true;
         if (acceptBtn) acceptBtn.disabled = true;
         if (rejectBtn) rejectBtn.disabled = true;
         return;
      }

      // status "9" + DISTRICT LEVEL: District ka Save/Submit/Reject sab band (Factory "9" upar)
      if (sfTrim === '9' && userLevel === 'DISTRICT LEVEL') {
         const saveBtn = document.getElementById("save");
         if (saveBtn) saveBtn.disabled = true;
         const submitBtn = document.getElementById("submit");
         if (submitBtn) submitBtn.disabled = true;
         const acceptBtn = document.getElementById("accept");
         if (acceptBtn) acceptBtn.disabled = true;
         const rejectBtn = document.getElementById("reject");
         if (rejectBtn) rejectBtn.disabled = true;
         return;
      }

      // 9 + Division/HQ: workflow ke hisaab se form edit band
      if (sfTrim === '9' && (userLevel === 'DIVISION LEVEL' || userLevel === 'HEAD QUARTER')) {
         const saveBtn = document.getElementById("save");
         if (saveBtn) saveBtn.disabled = true;
         const submitBtn = document.getElementById("submit");
         if (submitBtn) submitBtn.disabled = true;
         const acceptBtn = document.getElementById("accept");
         if (acceptBtn) acceptBtn.disabled = true;
         const rejectBtn = document.getElementById("reject");
         if (rejectBtn) rejectBtn.disabled = true;
         return;
      }

      // 3 = Division Submit ke baad sirf HQ (HQADM/HQASI): Accept/Reject on (as earlier), but Save disabled
      if (sfTrim === '3') {
         const saveBtn = document.getElementById("save");
         const submitBtn = document.getElementById("submit");
         const acceptBtn = document.getElementById("accept");
         const rejectBtn = document.getElementById("reject");
         const isHqAdmOrAsi = roles.includes('HQADM') || roles.includes('HQASI');

         if (userLevel === 'HEAD QUARTER' && isHqAsiAdminRole(roles) && isHqAdmOrAsi) {
            if (saveBtn) saveBtn.disabled = true;
            if (submitBtn) submitBtn.disabled = true;
            if (acceptBtn) acceptBtn.disabled = false;
            if (rejectBtn) rejectBtn.disabled = false;
            return;
         }

         if (saveBtn) saveBtn.disabled = true;
         if (submitBtn) submitBtn.disabled = true;
         if (acceptBtn) acceptBtn.disabled = true;
         if (rejectBtn) rejectBtn.disabled = true;
         return;
      }

      // 2 = Division Save — sirf DIVISION LEVEL: Save/Submit on; Reject disabled; District/Factory/HQ sab band
      if (sfTrim === '2') {
         const saveBtn = document.getElementById("save");
         const submitBtn = document.getElementById("submit");
         const acceptBtn = document.getElementById("accept");
         const rejectBtn = document.getElementById("reject");
         if (userLevel === 'DIVISION LEVEL') {
            if (saveBtn) saveBtn.disabled = false;
            if (submitBtn) submitBtn.disabled = false;
            if (acceptBtn) acceptBtn.disabled = true;
            if (rejectBtn) rejectBtn.disabled = true;
            return;
         }
         if (saveBtn) saveBtn.disabled = true;
         if (submitBtn) submitBtn.disabled = true;
         if (acceptBtn) acceptBtn.disabled = true;
         if (rejectBtn) rejectBtn.disabled = true;
         return;
      }

      // 7 = HQ Save — HEAD QUARTER: Save + Accept + Reject sab on; District/Division/Factory sab band
      if (sfTrim === '7') {
         const saveBtn = document.getElementById("save");
         const submitBtn = document.getElementById("submit");
         const acceptBtn = document.getElementById("accept");
         const rejectBtn = document.getElementById("reject");
         if (userLevel === 'HEAD QUARTER') {
            if (saveBtn) saveBtn.disabled = false;
            if (submitBtn) submitBtn.disabled = true;
            if (acceptBtn) acceptBtn.disabled = false;
            if (rejectBtn) rejectBtn.disabled = false;
            return;
         }
         if (saveBtn) saveBtn.disabled = true;
         if (submitBtn) submitBtn.disabled = true;
         if (acceptBtn) acceptBtn.disabled = true;
         if (rejectBtn) rejectBtn.disabled = true;
         return;
      }

      // 8 = HQ Accept / flow lock — HEAD QUARTER bhi Save/Accept/Reject sab band
      if (sfTrim === '8') {
         const saveBtn = document.getElementById("save");
         const submitBtn = document.getElementById("submit");
         const acceptBtn = document.getElementById("accept");
         const rejectBtn = document.getElementById("reject");
         if (saveBtn) saveBtn.disabled = true;
         if (submitBtn) submitBtn.disabled = true;
         if (acceptBtn) acceptBtn.disabled = true;
         if (rejectBtn) rejectBtn.disabled = true;
         return;
      }

      // status_flag 4 rules:
      // - DISTRICT LEVEL + DISASI: Save/Submit enabled; only Reject disabled
      // - HEAD QUARTER + HQADM/HQASI: Save/Submit/Accept/Reject all disabled
      // - everyone else: all disabled
      if (sfTrim === '4') {
         const isDisasi = roles.includes('DISASI');
         const isHqAsiAdmin = isHqAsiAdminRole(roles);

         const saveBtn = document.getElementById("save");
         const submitBtn = document.getElementById("submit");
         const acceptBtn = document.getElementById("accept");
         const rejectBtn = document.getElementById("reject");

         if (userLevel === 'DISTRICT LEVEL' && isDisasi) {
            if (saveBtn) saveBtn.disabled = false;
            if (submitBtn) submitBtn.disabled = false;
            if (acceptBtn) acceptBtn.disabled = true; // usually not shown for district
            if (rejectBtn) rejectBtn.disabled = true;
            return;
         }

         if (userLevel === 'HEAD QUARTER' && isHqAsiAdmin) {
            if (saveBtn) saveBtn.disabled = true;
            if (submitBtn) submitBtn.disabled = true;
            if (acceptBtn) acceptBtn.disabled = true;
            if (rejectBtn) rejectBtn.disabled = true;
            return;
         }

         if (saveBtn) saveBtn.disabled = true;
         if (submitBtn) submitBtn.disabled = true;
         if (acceptBtn) acceptBtn.disabled = true;
         if (rejectBtn) rejectBtn.disabled = true;
         return;
      }

      // statusFlag "6": only DIVASI + DIVISION LEVEL may Save/Submit.
      // For everyone else (including HQADM/HQ), Save/Submit disabled.
      // Accept/Reject should remain disabled at status 6.
      if (sfTrim === '6') {
         const allowed = isAsiStatusSixEditAllowedForRole(decode_token);

         const acceptBtn = document.getElementById("accept");
         if (acceptBtn) acceptBtn.disabled = true;
         const rejectBtn = document.getElementById("reject");
         if (rejectBtn) rejectBtn.disabled = true;

         const saveBtn = document.getElementById("save");
         if (saveBtn) saveBtn.disabled = !allowed;
         const submitBtn = document.getElementById("submit");
         if (submitBtn) submitBtn.disabled = !allowed;
      }

      if (userLevel === 'DIVISION LEVEL') {
         if (statusFlageval === "3" || statusFlageval === "7" || statusFlageval === "8")
            duser = 1;
      }
      if (statusFlageval === "4" || statusFlageval === "9") {
         const rejectBtn = document.getElementById("reject");
         if (rejectBtn) {
            rejectBtn.disabled = true;
         }
      }
      if (userLevel === 'HEAD QUARTER') {
         if (statusFlageval === "2" || statusFlageval === "6" || statusFlageval === "8") {
            duser = 1;
         }
         if (statusFlageval == "3") {
            duser = 2;
         }
      }
      if (duser === 2) {
         if (userLevel === 'HEAD QUARTER') {
            // HQADM/HQASI at statusFlag "3" should remain enabled
            if (!(sfTrim === '3' && isHqAsiAdminRole(roles))) {
               const saveBtn = document.getElementById("save");
               if (saveBtn) {
                  saveBtn.disabled = true;
               }
            }
         }
      }
      if (duser === 1) {
         const saveBtn = document.getElementById("save");
         if (saveBtn) {
            saveBtn.disabled = true;
         }
         if (userLevel === 'DIVISION LEVEL') {
            const submitBtn = document.getElementById("submit");
            if (submitBtn) {
               submitBtn.disabled = true;
            }
         }
         if (userLevel === 'HEAD QUARTER') {
            const acceptBtn = document.getElementById("accept");
            const rejectBtn = document.getElementById("reject");
            if (acceptBtn) {
               acceptBtn.disabled = true;
            }
            if (rejectBtn) {
               rejectBtn.disabled = true;
            }
         }
      }

      // status_flag "1": HQADM/HQASI — Save/Submit/Accept/Reject sab off
      // status_flag "1": DISASI + DISTRICT LEVEL — Submit & Reject off (Save via validateButtonASIBlock)
      // status_flag "1": DIVASI + DIVISION LEVEL — Submit & Reject on
      if (sfTrim === '1') {
         if (isHqAsiAdminRole(roles)) {
            const saveBtn = document.getElementById('save');
            if (saveBtn) saveBtn.disabled = true;
            const submitBtn = document.getElementById('submit');
            if (submitBtn) submitBtn.disabled = true;
            const acceptBtn = document.getElementById('accept');
            if (acceptBtn) acceptBtn.disabled = true;
            const rejectBtn = document.getElementById('reject');
            if (rejectBtn) rejectBtn.disabled = true;
         } else {
            const isDisasi = roles.includes('DISASI');
            if (isDisasi && userLevel === 'DISTRICT LEVEL') {
               const submitBtn = document.getElementById('submit');
               if (submitBtn) submitBtn.disabled = true;
               const rejectBtn = document.getElementById('reject');
               if (rejectBtn) rejectBtn.disabled = true;
            }
            if (isDivasi && userLevel === 'DIVISION LEVEL') {
               const submitBtn = document.getElementById('submit');
               if (submitBtn) submitBtn.disabled = false;
               const rejectBtn = document.getElementById('reject');
               if (rejectBtn) rejectBtn.disabled = false;
            }
         }
      }
   }, [decode_token, statusFlageval]);


   return (
      <div className="card-body">
         <h4 className="page_heading border-bottom-0">
            <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_N_TITLE : asiTitle.en.BLOCK_N_TITLE }} />
         </h4>

         <div className="row">
            <div className="col-12">
               <h6 className="fw-semibold">
                  {storedLanguage === 'hi' ? asiTitle.hi.DSL_NO : asiTitle.en.DSL_NO}: <span className="fw-normal me-5">{blockInfo.dslNo}</span>
                  {storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}: <span className="fw-normal">{yearRange}</span>
               </h6>
               <div className="table-responsive asi_block_table">
                  <table className="table table-bordered">
                     <thead>
                        <tr>
                           <th></th>
                           <th></th>
                           <th></th>
                        </tr>
                     </thead>
                     <tbody>
                        
                        <tr>
                           <td>Comments of Data Entry Officer/Scrutinising Officer</td>
                           <td colSpan="2">
                              <textarea
                                 cols="100"
                                 rows="2"
                                 className="form-control h-auto"
                                 name="comments_of_superintending_officer"
                                 value={commentsOfSuperintendingOfficer}
                                 maxLength="200"
                                 onChange={(e) => (hnadleTextBoxOnChange(e))}
                                 onBlur={(e) => handleInputSuperintendingOfficer(e.target.value)}
                              >
                              </textarea>
                              {superintendingNameError && <i style={{ color: 'red', fontSize: '12px' }}>{superintendingNameError}</i>}
                           </td>
                        </tr>
                        {/* Show Rejected Reason for years 2024-25 and onwards (surveyYear >= 2024) */}
                        {(() => {
                           const surveyYearNum = typeof blockInfo.surveyYear === 'string' 
                              ? parseInt(blockInfo.surveyYear.split('-')[0]) 
                              : parseInt(blockInfo.surveyYear);
                           const roles = decode_token.id.ROLE_CODE ? decode_token.id.ROLE_CODE.split('|') : [];
                           const isFACTO = roles.includes('FACTO');
                           return surveyYearNum >= 2024 && !isFACTO;
                        })() && (
                           <>
                              <tr>
                                 <td colSpan="3" className="bg-light text-center fw-bold">
                                    <h5>Rejected Reason</h5>
                                 </td>
                              </tr>
                              <tr>
                                 <td colSpan="3">
                                    <textarea
                                       cols="100"
                                       rows="2"
                                       className="form-control h-auto"
                                       name="rejectedReason"
                                       id="rejectedReason"
                                       value={blockLGVANVACalculation.rejectedReason}
                                       onChange={(e) => {
                                          setBlockLGVANVACalculation({
                                             ...blockLGVANVACalculation,
                                             rejectedReason: e.target.value
                                          });
                                       }}
                                       maxLength="500"
                                    >
                                    </textarea>
                                 </td>
                              </tr>
                           </>
                        )}
                        <tr>
                           <td colSpan="3">
                              <br />
                              <br />
                              Note: Reasons for negative working capital and for any abnormal values or entries (high or low) in respect to important characteristics (Such as GVA, working capital, wage rate, number of workers, distributive expenses, depreciation etc.) should be given invariably. For instance, the reasons for high GVA could be increased demand/production, profit, govt. subsidy; or for low GVA, the reasons could be decreased demand/production, capacity under-utilization, high input cost etc. Similarly, reasons for any abnormal values of certain important ratios e.g., Ratio of output to input, ratio of depreciation/distributive expenses to output etc. should be given.
                              <br />

                              <br />
                              <b>Please refer to detailed instructions also for further guidance</b>
                           </td>
                        </tr>
                     </tbody>
                  </table>

               </div>
            </div>
         </div>
         <div className="row">
            <div className="col-12">
               <hr />
            </div>

            <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
               <button
                  type="submit"
                  className="btn btn_orange me-1"
                  onClick={() => { window.print() }}
               >Print
                  <i className="fa fa-print ms-1"></i>
               </button>

               <button
                  type="button"
                  className="btn btn_orange me-1"
                  onClick={openPrintAllBlocksModal}
               >{printAllButtonLabel}
                  <i className="fa fa-print ms-1"></i>
               </button>

               {isHqAsiAdmin && (
                  <button
                     type="button"
                     className="btn btn_orange me-1"
                     onClick={() => setShowComparisonModal(true)}
                  >
                     Comparison Report
                  </button>
               )}

               <button
                  type="button"
                  className="btn btn_orange me-1"
                  onClick={(e) => { handleSaveData("SAVE") }}
                  disabled={buttonStatus || isStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag}
                  id="save"
               >
                  Save
               </button>

               {/* Show buttons for years 2024-25 and onwards (surveyYear >= 2024) */}
               {(() => {
                  const surveyYearNum = typeof blockInfo.surveyYear === 'string' 
                     ? parseInt(blockInfo.surveyYear.split('-')[0]) 
                     : parseInt(blockInfo.surveyYear);
                  return surveyYearNum >= 2024;
               })() && (
                  <>
                     {(decode_token.id.USER_TYPE === 'DISTRICT LEVEL' || decode_token.id.USER_TYPE === 'DIVISION LEVEL') &&
                        <>
                           <button type="button" className={`btn btn_orange mx-1`} 
                              onClick={(e)=>{handleSaveData("SUBMIT")}} id="submit"
                           >
                              Submit
                           </button>
                        </>
                     }

                     {(decode_token.id.USER_TYPE === 'HEAD QUARTER') &&
                        <>
                           <button type="button" className={`btn btn_orange mx-1`} 
                              onClick={(e)=>{handleSaveData("ACCEPT")}} id="accept"
                           >
                              Accept
                           </button>
                        </>
                     }

                     {(decode_token.id.USER_TYPE === 'DISTRICT LEVEL' || decode_token.id.USER_TYPE === 'HEAD QUARTER' || decode_token.id.USER_TYPE ==='DIVISION LEVEL') &&
                        <>
                           <button type="button" className={`btn btn_orange mx-1`} id="reject"
                              onClick={(e)=>{handleSaveData("REJECT")}}
                           >
                              Reject
                           </button>
                        </>
                     }

                     <button
                        type="button"
                        className="btn btn_orange mx-1"
                        onClick={handleRejectedReasonLog}
                        disabled={isRejectLogFetching}
                     >
                        {isRejectLogFetching ? 'Loading...' : 'Rejected Reason Log'}
                     </button>
                  </>
               )}

               <button
                  type="reset"
                  className="btn btn_orange me-1"
                  onClick={handleReset}
               >
                  Reset
               </button>

               <button
                  type="button"
                  className="btn btn_orange"
                  onClick={(e) => (navigate("/dashboard"))}
               >
                  Cancel
               </button>

            </div>

            <div className="col-lg-4 text-center text-lg-end">

               <button
                  type="button"
                  className="btn btn_orange mx-1"
                  onClick={() => (navigate('/BlockA'))}
               >
                  Block A
               </button>

               <button
                  type="button"
                  className="btn btn_orange mx-1"
                  onClick={handlePrevious}
               >
                  <i className="fa fa-angle-left me-1"></i>
                  Previous
               </button>



            </div>

         </div>

         {showPrintModal && createPortal(
            <div
               className="print-modal-overlay"
               role="dialog"
               aria-modal="true"
               onClick={handleModalOverlayClick}
            >
               <div className="print-modal-dialog" onClick={(e) => e.stopPropagation()}>
                  <div className="print-modal-content">
                     <div className="print-modal-header">
                        <div className="print-modal-header__content">
                           <h5 className="mb-1">{printPreviewTitle}</h5>
                           <small className="text-muted">
                              {isPrintPreparing
                                 ? `Loading sections: ${previewProgress} / ${activePrintSections.length}`
                                 : 'All sections loaded. Confirm to print when ready.'}
                           </small>
                        </div>
                        <button
                           type="button"
                           className="btn-close print-modal-close-btn"
                           aria-label="Close"
                           onClick={closePrintAllBlocksModal}
                        ></button>
                     </div>

                     <div className="print-modal-body">
                        {isPrintPreparing && (
                           <div className="alert alert-info mb-3">
                              Preparing preview: {previewProgress} / {activePrintSections.length} sections loaded.
                           </div>
                        )}
                        {activePrintSections.slice(0, previewProgress).map(({ key, label, Component, props }) => (
                           <div key={key} className={`print-section mb-4 print-all-block-section${key === 'A' || key === 'B' ? ' print-form-section' : ''}`}>
                              <div className="mb-2">
                                 <h6 className="mb-1">{label}</h6>
                              </div>
                              <div className="print-preview-block">
                                 <Suspense fallback={<div className="alert alert-secondary">Loading {label}...</div>}>
                                    <Component {...props} />
                                 </Suspense>
                              </div>
                           </div>
                        ))}
                     </div>

                     <div className="print-modal-footer text-end">
                        <button type="button" className="btn btn-secondary me-2 print-modal-action-btn" onClick={closePrintAllBlocksModal}>
                           Close
                        </button>
                        <button
                           type="button"
                           className="btn btn_orange print-modal-action-btn"
                           onClick={handleConfirmPrintAll}
                           // disabled={isPrintPreparing || previewProgress < activePrintSections.length}
                        >
                           {printAllButtonLabel}
                        </button>
                     </div>
                  </div>
               </div>
            </div>,
            document.body
         )}

         {showRejectLogModal && (
            <div
               className="modal fade show"
               style={modalOverlayStyle}
               role="dialog"
               aria-modal="true"
               onClick={closeRejectedReasonModal}
            >
               <div 
                  className="modal-dialog modal-lg modal-dialog-centered"
                  style={modalDialogStyle}
                  onClick={(e) => e.stopPropagation()}
               >
                  <div className="modal-content" style={modalContentStyle}>
                     <div className="modal-header">
                        <h5 className="modal-title">Rejected Reason Log</h5>
                        <button
                           type="button"
                           className="btn-close"
                           aria-label="Close"
                           onClick={closeRejectedReasonModal}
                        ></button>
                     </div>
                     <div className="modal-body">
                        {rejectLogError && (
                           <div className="alert alert-warning mb-3">
                              {rejectLogError}
                           </div>
                        )}
                        {!rejectLogError && rejectLog.length === 0 && (
                           <p className="mb-0">No rejected reason log found.</p>
                        )}
                        {rejectLog.length > 0 && (
                           <div className="table-responsive">
                              <table className="table table-bordered">
                                 <thead>
                                    <tr>
                                       <th>S.No</th>
                                       <th>Level</th>
                                       <th>Action</th>
                                       <th>Rejected Reason</th>
                                       <th>Date &amp; Time</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    {rejectLog.map((entry, index) => (
                                       <tr key={entry.id || index}>
                                          <td>{index + 1}</td>
                                          <td>{entry.level}</td>
                                          <td>{entry.action}</td>
                                          <td>{entry.reason}</td>
                                          <td>{entry.dateTime}</td>
                                       </tr>
                                    ))}
                                 </tbody>
                              </table>
                           </div>
                        )}
                     </div>
                     <div className="modal-footer">
                        <button
                           type="button"
                           className="btn btn-secondary"
                           onClick={closeRejectedReasonModal}
                        >
                           Close
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         )}

         {showComparisonModal && createPortal(
            <div
               className="comparison-modal-overlay"
               style={comparisonModalOverlayStyle}
               role="dialog"
               aria-modal="true"
               onClick={() => setShowComparisonModal(false)}
            >
               <div
                  className="comparison-modal-dialog"
                  style={comparisonModalDialogStyle}
                  onClick={(e) => e.stopPropagation()}
               >
                  <div className="modal-content comparison-modal-content" style={comparisonModalContentStyle}>
                     <div className="modal-header flex-shrink-0 border-0 py-2 px-3 comparison-report-no-print">
                        <button
                           type="button"
                           className="btn-close ms-auto"
                           aria-label="Close"
                           onClick={() => setShowComparisonModal(false)}
                        ></button>
                     </div>
                     <div
                        className="modal-body comparison-modal-body p-0 flex-grow-1"
                        style={comparisonModalBodyStyle}
                     >
                        <Suspense fallback={<div className="p-4 text-center">Loading...</div>}>
                           <ASIComparision
                              blockInfo={blockInfo}
                              config={config}
                              modalMode
                              onClose={() => setShowComparisonModal(false)}
                           />
                        </Suspense>
                     </div>
                     <div className="modal-footer flex-shrink-0 comparison-report-no-print">
                        <button
                           type="button"
                           className="btn btn-secondary"
                           onClick={() => setShowComparisonModal(false)}
                        >
                           Close
                        </button>
                     </div>
                  </div>
               </div>
            </div>,
            document.body
         )}

{showPrintModal && (

<style>{`
   .print-modal-overlay {
      position: fixed;
      inset: 0;
      width: 100vw;
      height: 100vh;
      min-width: 100%;
      min-height: 100%;
      z-index: 9999;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: flex-start;
      justify-content: center;
      padding: 20px;
      overflow-y: auto;
      box-sizing: border-box;
      pointer-events: auto;
   }

   .print-modal-dialog {
      max-width: 100%;
      width: 98%;
      margin: 1rem auto;
      flex-shrink: 0;
   }

   .print-modal-content {
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 0 20px rgba(0,0,0,0.35);
      padding: 20px;
      display: flex;
      flex-direction: column;
      max-height: 92vh;
   }

   .print-modal-header {
      border-bottom: 1px solid #e5e5e5;
      padding-bottom: 10px;
      margin-bottom: 15px;
      flex-shrink: 0;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
   }

   .print-modal-header__content {
      flex: 1;
      min-width: 0;
   }

   .print-modal-close-btn {
      flex-shrink: 0;
      margin-top: 2px;
   }

   .print-modal-body {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
   }

   .print-preview-block .btn,
   .print-preview-block .btn_orange,
   .print-preview-block .btn-secondary {
      display: none !important;
   }

   .print-preview-block .table-responsive,
   .print-preview-block .asi_block_table {
      overflow-x: auto !important;
      max-width: 100%;
      max-height: none !important;
   }

   .print-all-block-section .print-preview-block .card-body {
      font-size: 14px;
      line-height: 22px;
      color: #000;
   }

   .print-all-block-section .print-preview-block .page_heading {
      font-size: inherit;
      margin-bottom: 20px;
   }

   .print-all-block-section .print-preview-block h6 {
      font-size: 14px;
      line-height: 22px;
      color: #000;
   }

   .print-all-block-section .print-preview-block label {
      display: block;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 6px;
      line-height: 22px;
      color: #000;
   }

   .print-all-block-section .print-preview-block input.form-control,
   .print-all-block-section .print-preview-block select.form-select,
   .print-all-block-section .print-preview-block textarea.form-control,
   .print-all-block-section .print-preview-block .status-unit-dropdown__readonly {
      font-size: 14px;
      line-height: 22px;
      color: #383838;
      border: 1px solid #BDBDBD;
      border-radius: 4px;
      background-color: #fff;
   }

   .print-all-block-section .print-preview-block .block_c_table,
   .print-all-block-section .print-preview-block .asi_block_table table {
      font-size: 14px !important;
   }

   .print-all-block-section .print-preview-block .block_c_table th,
   .print-all-block-section .print-preview-block .block_c_table td,
   .print-all-block-section .print-preview-block .asi_block_table th,
   .print-all-block-section .print-preview-block .asi_block_table td {
      font-size: 14px !important;
      padding: 4px 6px !important;
      white-space: normal !important;
      word-break: break-word !important;
      vertical-align: middle !important;
      color: #000;
   }

   .print-all-block-section .print-preview-block .block_c_table input.form-control,
   .print-all-block-section .print-preview-block .block_c_table select.form-select,
   .print-all-block-section .print-preview-block .block_c_table textarea.form-control,
   .print-all-block-section .print-preview-block .asi_block_table input.form-control,
   .print-all-block-section .print-preview-block .asi_block_table select.form-select,
   .print-all-block-section .print-preview-block .asi_block_table textarea.form-control {
      font-size: 14px !important;
      line-height: 22px !important;
      height: auto;
      min-height: 28px;
      padding: 3px 6px !important;
      min-width: 0;
      width: 100%;
      color: #383838 !important;
      border: 1px solid #BDBDBD !important;
      background-color: #fff !important;
   }

   .print-preview-block .block_c_table {
      width: 100% !important;
      table-layout: auto !important;
   }

   .print-preview-block .block_c_table:not(.block-e-print-table) th:first-child,
   .print-preview-block .block_c_table:not(.block-e-print-table) td:first-child {
      width: 28px !important;
      max-width: 32px !important;
      min-width: 24px !important;
      text-align: center !important;
      white-space: nowrap !important;
      word-break: normal !important;
      padding: 2px 2px !important;
   }

   .print-preview-block .block-e-print-table {
      table-layout: fixed !important;
   }

   .print-preview-block .block-e-print-table col.block-e-col-sl {
      width: 10px !important;
      max-width: 10px !important;
   }

   .print-preview-block .block-e-print-table th.block-e-sl-col,
   .print-preview-block .block-e-print-table tbody td:first-child,
   .print-preview-block .block-e-print-table thead tr:last-child th:first-child {
      width: 10px !important;
      max-width: 10px !important;
      min-width: 10px !important;
      text-align: center !important;
      white-space: nowrap !important;
      word-break: normal !important;
      padding: 2px 2px !important;
      font-size: 14px !important;
   }
   .print-preview-block .block-e-print-table col.block-e-col-cat { width: 20%; }
   .print-preview-block .block-e-print-table col.block-e-col-mfg { width: 13%; }
   .print-preview-block .block-e-print-table col.block-e-col-nonmfg { width: 8%; }
   .print-preview-block .block-e-print-table col.block-e-col-total { width: 6%; }
   .print-preview-block .block-e-print-table col.block-e-col-avg { width: 11%; }
   .print-preview-block .block-e-print-table col.block-e-col-mandays { width: 10%; }
   .print-preview-block .block-e-print-table col.block-e-col-salary { width: 10%; }

   .print-preview-block .block_c_table th,
   .print-preview-block .block_c_table td {
      padding: 4px 6px !important;
      white-space: normal !important;
      word-break: break-word !important;
      vertical-align: middle !important;
   }

   .print-form-section {
      overflow: visible;
   }

   .print-preview-block .card-body {
      max-width: 100%;
      overflow: hidden;
      padding: 0.5rem;
   }

   .print-section {
      overflow: hidden;
      padding-bottom: 12px;
      max-width: 100%;
   }

   .print-modal-footer {
      border-top: 1px solid #e5e5e5;
      padding-top: 15px;
      margin-top: 15px;
      flex-shrink: 0;
      position: sticky;
      bottom: 0;
      background: #fff;
      z-index: 2;
   }

   .print-keep-together {
      page-break-inside: avoid;
      break-inside: avoid;
   }

   .print-form-section .print-preview-block .row {
      display: flex !important;
      flex-wrap: wrap !important;
      margin-right: -0.75rem;
      margin-left: -0.75rem;
   }

   .print-form-section .print-preview-block [class*="col-"] {
      padding-right: 0.75rem;
      padding-left: 0.75rem;
   }

   .print-form-section .print-preview-block .col-lg-3,
   .print-form-section .print-preview-block .col-md-4,
   .print-form-section .print-preview-block .col-sm-6 {
      flex: 0 0 25%;
      max-width: 25%;
   }

   .print-form-section .print-preview-block .col-xl-4,
   .print-form-section .print-preview-block .col-lg-6,
   .print-form-section .print-preview-block .col-md-6 {
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
   }

   .print-form-section .print-preview-block .col-12 {
      flex: 0 0 100%;
      max-width: 100%;
   }

   .print-form-section .print-preview-block .mb-3 input.form-control,
   .print-form-section .print-preview-block .mb-3 select.form-select,
   .print-form-section .print-preview-block .mb-3 textarea.form-control,
   .print-form-section .print-preview-block .status-unit-dropdown__readonly {
      width: 100%;
      height: 48px;
      min-height: 48px;
      font-size: 14px;
      line-height: 22px;
      padding: 6px 12px;
      border: 1px solid #BDBDBD;
      border-radius: 4px;
      background-color: #fff;
      color: #383838;
   }

   .print-form-section .print-preview-block .mb-3 textarea.form-control {
      height: auto;
      min-height: 48px;
   }

   .print-form-section .print-preview-block .mb-3 select.form-select,
   .print-form-section .print-preview-block .status-unit-dropdown__readonly {
      height: auto;
      min-height: 48px;
      white-space: normal;
      word-break: break-word;
   }

   .print-form-section .print-preview-block .mb-3 input.form-control:disabled,
   .print-form-section .print-preview-block .mb-3 select.form-select:disabled {
      background-color: #e9ecef;
      opacity: 1;
      color: #383838;
   }

   @page {
      size: landscape;
      margin: 8mm;
   }

   @media print {
      body * {
         visibility: hidden !important;
      }
      .print-modal-content, .print-modal-content * {
         visibility: visible !important;
      }
      .print-modal-header {
         display: none !important;
      }
      .print-modal-footer,
      .print-modal-action-btn {
         display: none !important;
      }
      .print-modal-body, .print-modal-dialog, .print-modal-content, .print-modal-overlay {
         max-height: none !important;
         height: auto !important;
         overflow: visible !important;
      }
      .print-modal-content {
         position: absolute !important;
         left: 0 !important;
         top: 0 !important;
         width: 100% !important;
         box-shadow: none !important;
         margin: 0 !important;
         padding: 0 !important;
      }
      .print-modal-overlay {
         position: static !important;
         background: transparent !important;
         padding: 0 !important;
      }
      .print-section {
         page-break-inside: auto;
         break-inside: auto;
         overflow: visible !important;
      }
      .print-section:not(:last-child) {
         page-break-after: always;
         break-after: page;
      }
      .print-keep-together {
         page-break-inside: avoid !important;
         break-inside: avoid !important;
      }
      .print-preview-block .table-responsive,
      .print-preview-block .asi_block_table,
      .table-responsive {
         overflow: visible !important;
         max-height: none !important;
         height: auto !important;
      }
      .print-preview-block table,
      table {
         width: 100% !important;
         table-layout: auto !important;
      }
      .print-all-block-section .print-preview-block .card-body,
      .print-all-block-section .print-preview-block label,
      .print-all-block-section .print-preview-block h6,
      .print-all-block-section .print-preview-block .page_heading {
         font-size: 14px !important;
         line-height: 22px !important;
         color: #000 !important;
      }
      .print-all-block-section .print-preview-block input.form-control,
      .print-all-block-section .print-preview-block select.form-select,
      .print-all-block-section .print-preview-block textarea.form-control,
      .print-all-block-section .print-preview-block .status-unit-dropdown__readonly {
         font-size: 14px !important;
         line-height: 22px !important;
         color: #383838 !important;
         -webkit-text-fill-color: #383838 !important;
      }
      .print-preview-block .block_c_table,
      .block_c_table,
      .print-all-block-section .print-preview-block .block_c_table th,
      .print-all-block-section .print-preview-block .block_c_table td,
      .print-all-block-section .print-preview-block .asi_block_table th,
      .print-all-block-section .print-preview-block .asi_block_table td {
         font-size: 14px !important;
      }
      .print-preview-block .block_c_table:not(.block-e-print-table) th:first-child,
      .print-preview-block .block_c_table:not(.block-e-print-table) td:first-child,
      .block_c_table:not(.block-e-print-table) th:first-child,
      .block_c_table:not(.block-e-print-table) td:first-child {
         width: 24px !important;
         max-width: 28px !important;
         min-width: 20px !important;
         text-align: center !important;
         white-space: nowrap !important;
         word-break: normal !important;
         padding: 2px 2px !important;
      }
      .print-preview-block .block-e-print-table {
         table-layout: fixed !important;
      }
      .print-preview-block .block-e-print-table col.block-e-col-sl {
         width: 10px !important;
         max-width: 10px !important;
      }
      .print-preview-block .block-e-print-table th.block-e-sl-col,
      .print-preview-block .block-e-print-table tbody td:first-child,
      .print-preview-block .block-e-print-table thead tr:last-child th:first-child {
         width: 10px !important;
         max-width: 10px !important;
         min-width: 10px !important;
         text-align: center !important;
         white-space: nowrap !important;
         padding: 2px 2px !important;
         font-size: 14px !important;
      }
      .print-preview-block .block-e-print-table col.block-e-col-cat { width: 20% !important; }
      .print-preview-block .block-e-print-table col.block-e-col-mfg { width: 13% !important; }
      .print-preview-block .block-e-print-table col.block-e-col-nonmfg { width: 8% !important; }
      .print-preview-block .block-e-print-table col.block-e-col-total { width: 6% !important; }
      .print-preview-block .block-e-print-table col.block-e-col-avg { width: 11% !important; }
      .print-preview-block .block-e-print-table col.block-e-col-mandays { width: 10% !important; }
      .print-preview-block .block-e-print-table col.block-e-col-salary { width: 10% !important; }
      .print-preview-block .block_c_table th,
      .print-preview-block .block_c_table td,
      .block_c_table th,
      .block_c_table td {
         white-space: normal !important;
         word-break: break-word !important;
         padding: 4px 6px !important;
         font-size: 14px !important;
         overflow: visible !important;
      }
      .print-preview-block .block_c_table input.form-control,
      .print-preview-block .block_c_table select.form-select,
      .print-preview-block .block_c_table textarea.form-control,
      .print-all-block-section .print-preview-block .asi_block_table input.form-control,
      .print-all-block-section .print-preview-block .asi_block_table select.form-select,
      .print-all-block-section .print-preview-block .asi_block_table textarea.form-control {
         font-size: 14px !important;
         line-height: 22px !important;
         min-height: 28px !important;
         padding: 3px 6px !important;
         color: #383838 !important;
         -webkit-text-fill-color: #383838 !important;
      }
      thead {
         display: table-header-group;
      }
      tr {
         page-break-inside: avoid;
         break-inside: avoid;
      }
      .print-preview-block .block_c_table input.form-control,
      .print-preview-block .block_c_table select.form-select,
      .print-preview-block .block_c_table textarea.form-control {
         border: none !important;
         background: transparent !important;
         color: #000 !important;
         box-shadow: none !important;
         -webkit-print-color-adjust: exact;
         print-color-adjust: exact;
      }
      .print-form-section .print-preview-block .card-body {
         overflow: visible !important;
         padding: 0.5rem !important;
      }
      .print-form-section .print-preview-block .row {
         display: flex !important;
         flex-wrap: wrap !important;
         margin-right: -0.75rem !important;
         margin-left: -0.75rem !important;
      }
      .print-form-section .print-preview-block [class*="col-"] {
         padding-right: 0.75rem !important;
         padding-left: 0.75rem !important;
         page-break-inside: avoid !important;
         break-inside: avoid !important;
      }
      .print-form-section .print-preview-block .col-lg-3,
      .print-form-section .print-preview-block .col-md-4,
      .print-form-section .print-preview-block .col-sm-6 {
         flex: 0 0 25% !important;
         max-width: 25% !important;
         width: 25% !important;
      }
      .print-form-section .print-preview-block .col-xl-4,
      .print-form-section .print-preview-block .col-lg-6,
      .print-form-section .print-preview-block .col-md-6 {
         flex: 0 0 33.333333% !important;
         max-width: 33.333333% !important;
         width: 33.333333% !important;
      }
      .print-form-section .print-preview-block .col-12 {
         flex: 0 0 100% !important;
         max-width: 100% !important;
         width: 100% !important;
      }
      .print-form-section .print-preview-block .mb-3 input.form-control,
      .print-form-section .print-preview-block .mb-3 select.form-select,
      .print-form-section .print-preview-block .mb-3 textarea.form-control,
      .print-form-section .print-preview-block .status-unit-dropdown__readonly {
         display: block !important;
         width: 100% !important;
         height: 48px !important;
         min-height: 48px !important;
         font-size: 14px !important;
         line-height: 22px !important;
         padding: 6px 12px !important;
         border: 1px solid #BDBDBD !important;
         border-radius: 4px !important;
         background-color: #fff !important;
         color: #383838 !important;
         box-shadow: none !important;
         opacity: 1 !important;
         -webkit-text-fill-color: #383838 !important;
         -webkit-print-color-adjust: exact !important;
         print-color-adjust: exact !important;
      }
      .print-form-section .print-preview-block .mb-3 textarea.form-control {
         height: auto !important;
         min-height: 48px !important;
      }
      .print-form-section .print-preview-block .mb-3 select.form-select,
      .print-form-section .print-preview-block .status-unit-dropdown__readonly {
         height: auto !important;
         min-height: 48px !important;
         white-space: normal !important;
         word-break: break-word !important;
      }
      .print-form-section .print-preview-block .mb-3 input.form-control:disabled,
      .print-form-section .print-preview-block .mb-3 select.form-select:disabled {
         background-color: #e9ecef !important;
         color: #383838 !important;
         -webkit-text-fill-color: #383838 !important;
      }
      .print-form-section .print-preview-block select.form-select {
         -webkit-appearance: menulist !important;
         appearance: menulist !important;
      }
      .status-unit-dropdown__chevron {
         display: none !important;
      }
      .alert {
         display: none !important;
      }
   }
`}</style>
)
}

      </div>
   )
}
